import { GetCompletedCreditCardTransactions, GetCreditCardTransactionsThatNeedApproval, GetFailedTransactions, GetOpenPreAuthorizations, GetVoidedCreditCardTransactions } from "../../../../services/requests/billing/dewar-billing-requests";
import { DataSource } from "../../../UI/view/data-source";

export const needsApprovalDataSource = {
  name: 'ccNeedsApproval',
  request: GetCreditCardTransactionsThatNeedApproval,
  pk: 'transactionId',
} as DataSource;

export const failedTransactionsDS = {
  name: 'ccFailedTransactions',
  request: GetFailedTransactions,
  pk: 'transactionId',
}

export const openPreAuthDS = {
  name: 'ccOpenPreAuth',
  request: GetOpenPreAuthorizations,
  pk: 'transactionId',
}

export const completedTransactionsDS = {
  name: 'ccCompletedTransactions',
  request: GetCompletedCreditCardTransactions,
  pk: 'transactionId',
}

export const voidedTransactionsDS = {
  name: 'ccVoidedTransactions',
  request: GetVoidedCreditCardTransactions,
  pk: 'transactionId',
}